var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Cloudinary } from "@cloudinary/url-gen";
import { validateImage } from "../utils/media.util";
var CloudinaryService = /** @class */ (function () {
    function CloudinaryService() {
    }
    CloudinaryService.uploadMedia = function (validationId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!window.cloudinary) {
                    throw new Error('Cloudinary is not initialized');
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var widgetOptions = __assign({ cloudName: "crqlar", uploadPreset: "swinkk5a", autoUpload: false, sources: ['local', 'url', 'camera'], clientAllowedFormats: ['png', 'jpeg', 'jpg'], folder: 'uploads' }, options);
                        var widget = window.cloudinary.createUploadWidget(widgetOptions, function (error, result) { return __awaiter(_this, void 0, void 0, function () {
                            var validateMediaFile;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (error) {
                                            widget.close();
                                            return [2 /*return*/, reject(error)];
                                        }
                                        if (!(result.event === 'success' && result.info)) return [3 /*break*/, 3];
                                        if (!(validationId === 'my-account-image' || validationId === 'image-picker-organization')) return [3 /*break*/, 2];
                                        return [4 /*yield*/, validateImage(result.info, validationId)];
                                    case 1:
                                        validateMediaFile = _a.sent();
                                        if (!validateMediaFile.isValid) {
                                            widget.close();
                                            return [2 /*return*/, reject(validateMediaFile.message)];
                                        }
                                        _a.label = 2;
                                    case 2:
                                        // ✅ All validations passed
                                        widget.close();
                                        return [2 /*return*/, resolve(result.info)];
                                    case 3:
                                        if (result.event === 'validation-error') {
                                            alert("Validation failed.");
                                            widget.close();
                                            return [2 /*return*/, reject(new Error("Cloudinary widget validation error"))];
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        widget.open();
                    })];
            });
        });
    };
    CloudinaryService.uploadMultipleMedia = function (validationId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!window.cloudinary) {
                    throw new Error('Cloudinary is not initialized');
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var uploadedResources = [];
                        var widgetOptions = __assign({ cloudName: "crqlar", uploadPreset: "swinkk5a", autoUpload: false, sources: ['local', 'url', 'camera'], clientAllowedFormats: ['png', 'jpeg', 'jpg'], folder: 'uploads', multiple: true }, options);
                        var widget = window.cloudinary.createUploadWidget(widgetOptions, function (error, result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (error) {
                                    widget.close();
                                    return [2 /*return*/, reject(error)];
                                }
                                if (result.event === 'success' && result.info) {
                                    // Collect each uploaded file
                                    uploadedResources.push(result.info);
                                }
                                if (result.event === 'queues-end') {
                                    // All uploads complete
                                    widget.close();
                                    if (uploadedResources.length > 0) {
                                        return [2 /*return*/, resolve(uploadedResources)];
                                    }
                                    else {
                                        return [2 /*return*/, reject(new Error('No files were uploaded'))];
                                    }
                                }
                                if (result.event === 'close') {
                                    // Widget closed - resolve with whatever we have
                                    if (uploadedResources.length > 0) {
                                        return [2 /*return*/, resolve(uploadedResources)];
                                    }
                                    else {
                                        return [2 /*return*/, reject(new Error('Upload cancelled'))];
                                    }
                                }
                                if (result.event === 'validation-error') {
                                    alert("Validation failed.");
                                    widget.close();
                                    return [2 /*return*/, reject(new Error("Cloudinary widget validation error"))];
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        widget.open();
                    })];
            });
        });
    };
    CloudinaryService.upload = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('upload_preset', 'swinkk5a');
                        formData.append('file', file);
                        return [4 /*yield*/, fetch("https://api.cloudinary.com/v1_1/crqlar/upload", {
                                method: 'POST',
                                body: formData
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    CloudinaryService.getSanitizedSvgDeliveryUrl = function (url) {
        if (!url)
            return url;
        var uploadSegment = '/image/upload/';
        var sanitizedUploadSegment = "".concat(uploadSegment, "fl_sanitize/");
        if (!url.includes(uploadSegment) || url.includes(sanitizedUploadSegment))
            return url;
        return url.replace(uploadSegment, sanitizedUploadSegment);
    };
    // upload an arbitrary file (pdf, image, …) via cloudinary's auto endpoint; returns the raw response (secure_url, public_id, …)
    CloudinaryService.uploadFile = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('upload_preset', 'swinkk5a');
                        formData.append('file', file);
                        return [4 /*yield*/, fetch("https://api.cloudinary.com/v1_1/crqlar/auto/upload", {
                                method: 'POST',
                                body: formData
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    CloudinaryService.getImage = function (media) {
        if (!(media === null || media === void 0 ? void 0 : media.publicId))
            return;
        var cld = new Cloudinary({
            cloud: {
                cloudName: 'crqlar'
            }
        });
        return cld.image(media === null || media === void 0 ? void 0 : media.publicId);
    };
    return CloudinaryService;
}());
export { CloudinaryService };
